import {
  EnvironmentName,
  EnvironmentSpecificEnv,
} from './environment-specific.type';

export const environmentSpecificEnv: EnvironmentSpecificEnv = {
  environmentName: EnvironmentName.STAGE,
  production: true,
  // using dev variables as this is not prod ready
  // dev,qa,and stage are using the prod flag right now
  // googleAnalytics: {
  //   id: 'UA-31203397-6',
  //   tag: 'GTM-K8TC847'
  // }
  googleAnalytics: {
    id: 'UA-31203397-3',
    tag: 'GTM-K8TC847',
  },
  recaptchaKey: '6Le-VWUqAAAAAPKHxVndckZ4NKNjSmf_YEN-VbNG',
  oktaClientId: '0oa1c3f10yqPqRv6h0h8',
  oktaIssuer:
    'https://alliancewebs.oktapreview.com/oauth2/auslliad098ikdxec0h7',
  splitKey: 'st8p512g304opu3dba8cmk8vnc2lql62cm9e',
  showOktaSignInButton: true,
  apiSubDomain: 'stage-api',
};
